import _isNil from "lodash/isNil";
import { analysisTools } from 'const';
import createMemoizedSelector from 'redux/selectors/createMemoizedSelector';
import getIsImmuneOnly from 'redux/selectors/experimentSettings/getIsImmuneOnly';
var getAnalysisTool = function getAnalysisTool() {
  return function (state) {
    var _state$experimentSett;
    var analysisTool = (_state$experimentSett = state.experimentSettings) === null || _state$experimentSett === void 0 || (_state$experimentSett = _state$experimentSett.processing) === null || _state$experimentSett === void 0 || (_state$experimentSett = _state$experimentSett.dataIntegration) === null || _state$experimentSett === void 0 ? void 0 : _state$experimentSett.analysisTool;
    var isImmuneOnly = getIsImmuneOnly()(state.experimentSettings);
    if (isImmuneOnly) return analysisTools.SCANPY;
    if (_isNil(analysisTool)) {
      return null;
    }
    return analysisTool;
  };
};
export default createMemoizedSelector(getAnalysisTool);